import { all, call, Effect, fork, put, takeLatest } from 'redux-saga/effects';
import { standardiseError } from '../../utils/error';
import { normalise } from '../../utils/request';
import { getCurrentUserAction, setCurrentUserAction, setUserErrorAction } from './actions';
import { getCurrentUser, Response } from './api';

export function* handleGetCurrentUser(action: ReturnType<typeof getCurrentUserAction>): Generator<Effect> {
  try {
    const response = (yield call(getCurrentUser, action.payload.id)) as Response;
    yield put(setCurrentUserAction({ user: normalise(response) }));
  } catch (e) {
    const error = standardiseError(e);
    yield put(setUserErrorAction({ error }));
  }
}

function* watchGetCurrentUser() {
  yield takeLatest(getCurrentUserAction, handleGetCurrentUser);
}

export function* userSagas(): Generator<Effect> {
  yield all([fork(watchGetCurrentUser)]);
}
